export const REQUEST_LOGIN = "REQUEST_LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_NO_COOKIE_SET = "LOGIN_NO_COOKIE_SET";

export const REQUEST_LOGOUT = "REQUEST_LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "LOGOUT_ERROR";

export const REQUEST_GOOGLELOGIN = "REQUEST_GOOGLELOGIN";
export const GOOGLELOGIN_SUCCESS = "GOOGLELOGIN_SUCCESS";
export const GOOGLELOGIN_ERROR = "GOOGLELOGIN_ERROR";

export const REQUEST_GOOGLELOGOUT = "REQUEST_GOOGLELOGOUT";
export const GOOGLELOGOUT_SUCCESS = "GOOGLELOGOUT_SUCCESS";
export const GOOGLELOGOUT_ERROR = "GOOGLELOGOUT_ERROR";

export const REQUEST_ISADMIN = "REQUEST_ISADMIN";
export const ISADMIN_SUCCESS = "ISADMIN_SUCCESS";
export const ISADMIN_ERROR = "ISADMIN_ERROR";

export const REQUEST_RESET_COOKIE = "REQUEST_RESET_COOKIE";
export const RESET_COOKIE_SUCCESS = "RESET_COOKIE_SUCCESS";
export const RESET_COOKIE_ERROR = "RESET_COOKIE_ERROR";

export const REQUEST_ACTIVE_DIRECTORY_LOGIN = "REQUEST_ACTIVE_DIRECTORY_LOGIN";
export const LOGIN_ACTIVE_DIRECTORY_SUCCESS = "LOGIN_ACTIVE_DIRECTORY_SUCCESS";
export const LOGIN_ACTIVE_DIRECTORY_ERROR = "LOGIN_ACTIVE_DIRECTORY_ERROR";

export const LOGIN_ERASE_ERROR = "LOGIN_ERASE_ERROR";

export const REQUEST_MICROSOFT_LOGIN = "REQUEST_MICROSOFT_LOGIN";
export const LOGIN_MICROSOFT_SUCCESS = "LOGIN_MICROSOFT_SUCCESS";
export const LOGIN_MICROSOFT_ERROR = "LOGIN_MICROSOFT_ERROR";
